import { useEffect, useMemo, useRef } from "react";
import { createContext } from "react";
import socketIO from "socket.io-client";

export const SocketDeliveryContext = createContext(null);

export const SocketDeliverProvider = ({ children, url }) => {
  const socketRef = useRef(null);

  // Inicializa o socket apenas uma vez
  if (!socketRef.current) {
    socketRef.current = socketIO.connect(url, {
      transports: ["websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });
  }

  useEffect(() => {
    const socket = socketRef.current;

    const onConnect = () => console.log("Socket conectado:", socket.id);
    const onDisconnect = () => console.log("Socket desconectado");

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, []);

  // Funções de socket
  const emitSocket = (event, data) => {
    const socket = socketRef.current;
    if (!socket.connected) {
      // Caso desconectado, espera reconectar
      socket.once("connect", () => socket.emit(event, {socketID: socket.id, ...data}));
    } else {
      socket.emit(event, {socketID: socket.id, ...data});
    }
  };

  const listenSocket = (event, callback) => {
    const socket = socketRef.current;
    socket.on(event, callback);
    return () => socket.off(event, callback);
  };

  const closeSocket = (event) => {
    socketRef.current?.off(event);
  };

  // Memoiza o contexto para não disparar re-renders desnecessários
  const contextValues = useMemo(() => ({
    socket: socketRef.current,
    emitSocket,
    listenSocket,
    closeSocket
  }), [emitSocket, listenSocket, closeSocket]);

  return (
    <SocketDeliveryContext.Provider value={contextValues}>
      {children}
    </SocketDeliveryContext.Provider>
  );
};

